import React from 'react';
import PropTypes from 'prop-types';

const ViewDate = ({ data }) => {
  let datestring = "";

  if ((data) && (data !== null) && (typeof data.getMonth === 'function')) {
    let day = data.getDate().toString();
    if (data.getDate() < 10) {
      day = "0" + data.getDate().toString();
    }
    let month = (data.getMonth() + 1).toString();
    if (data.getMonth() + 1 < 10) {
      month = "0" + (data.getMonth() + 1).toString();
    }
    datestring = day + "." + month + "." + data.getFullYear();
    
    //console.debug("WHAT THE FUCK", data, new Date(1, 0, 1, 0, 0, 0, 0) );
    if (data < new Date(1, 0, 1, 0, 0, 0, 0)){
      datestring = "";
    }
  }

  

  return (
    <span>{datestring}</span>
  );
};

ViewDate.propTypes = {
  data: PropTypes.object,
};

export default ViewDate;



// WEBPACK FOOTER //
// ./src/components/Display/ViewDate.js